import {TypedDocumentString} from '~/graphql-react-query/graphql';
import {useAuth} from 'bigdatr-style';
import {ApiError} from 'bigdatr-style/src/error/errors';
import useGetPointingStagingToProductionData from '~/util/useGetPointingStagingToProductionData';
import useFeatureFlags from '~/util/useFeatureFlags';

/**
 * Uses our authorized fetch to add correct headers and error handling for requests,
 * and uses the graphql codegen to type the payload and response */
export default function useClientMainAuthorizedFetch() {
    const {queryNewApiEntityDomain} = useFeatureFlags();
    const {authorizedFetch} = useAuth();
    const {isAllowedToPointStagingToProduction, pointStagingToProduction} =
        useGetPointingStagingToProductionData();

    let entityApiUrl = process.env.BIGDATR_ENTITY_API_ENDPOINT || '';
    if (queryNewApiEntityDomain) entityApiUrl = process.env.ENTITY_API_ENDPOINT || '';
    if (isAllowedToPointStagingToProduction && pointStagingToProduction) {
        const prodUrlForStaging = process.env.PRODUCTION_BIGDATR_ENTITY_API_ENDPOINT;
        if (!prodUrlForStaging) {
            throw new Error(
                'Tried to point staging to production API, but the prod API URL is not provided'
            );
        }
        entityApiUrl = prodUrlForStaging;
    }

    return async <TResult, TVariables>(
        query: TypedDocumentString<TResult, TVariables>,
        ...[variables]: TVariables extends Record<string, never> ? [] : [TVariables]
    ) => {
        const response = await authorizedFetch(entityApiUrl, {
            query,
            variables
        });

        if (response.errors) {
            const firstError = response.errors[0];
            if (!firstError) throw new Error('No error returned from authorizedFetch');
            throw new ApiError(firstError);
        }

        return response.data as TResult;
    };
}
